import { useMemo } from 'react'

import { DEFAULT_UNIVERSAL_SEARCH_CONFIG, UniversalSearchConfig } from '../../devTools/utils'
import { CategoryPriorityConfig, DEFAULT_CATEGORY_PRIORITY } from '../types'

export interface UseUniversalSearchConfigOptions {
  /** LaunchDarkly fusejs settings config values (partial) */
  ldConfig?: Partial<UniversalSearchConfig>
  /** LaunchDarkly category priority values used for results sorting (partial) */
  ldCategoryPriority?: Partial<CategoryPriorityConfig>
  /** DevTools config overrides (partial) */
  devToolsConfig?: Partial<UniversalSearchConfig>
}

export interface UseUniversalSearchConfigResult {
  /** Merged search config (DevTools > LaunchDarkly > defaults) */
  config: UniversalSearchConfig
  /** Merged category priority (LaunchDarkly > defaults) */
  categoryPriority: CategoryPriorityConfig
}

/**
 * Shared hook to merge Universal Search configuration from multiple sources.
 * Config priority: DevTools > LaunchDarkly > defaults.
 */
export const useUniversalSearchConfig = ({
  ldConfig,
  ldCategoryPriority,
  devToolsConfig,
}: UseUniversalSearchConfigOptions): UseUniversalSearchConfigResult => {
  const config = useMemo(
    () => ({ ...DEFAULT_UNIVERSAL_SEARCH_CONFIG, ...ldConfig, ...devToolsConfig }),
    [ldConfig, devToolsConfig],
  )

  const categoryPriority = useMemo(
    () => ({ ...DEFAULT_CATEGORY_PRIORITY, ...ldCategoryPriority }),
    [ldCategoryPriority],
  )

  return { config, categoryPriority }
}
